import styled from "styled-components";

const SelectContainer = styled.div`
  /* Estilos para el contenedor del select */
`;

const SelectInput = styled.select`
  /* Estilos para el select */
 border-radius: 8px; /* Bordes redondeados */
  padding: 4px 8px; /* Tamaño pequeño */
  font-size: 14px; /* Tamaño del texto */
  border: 1px solid #d0d0d0; /* Color del borde */
  outline: none; /* Quitar el borde por defecto al enfocarse */
  min-width: 100px; /* Ancho mínimo para el select */
  width: auto; /* Ajustar el ancho según el contenido */
  white-space: nowrap; /* Evitar el salto de línea */
  
  &:focus {
    border-color: #007bff; /* Color del borde al enfocar */
    box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, 0.25); /* Sombra del borde al enfocar */
  }
`;


type TProps = {
  documentType: string;
  setDocumentType: (value: string) => void;
};

const DocumentSelectInput = ({ documentType, setDocumentType }: TProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setDocumentType(event.target.value);
  };

  return (
    <SelectContainer>
      <label htmlFor="documentType">Tipo de Documento:  </label>
      <SelectInput
        id="documentType"
        value={documentType}
        onChange={handleChange}
      >
        <option value="DNI">DNI</option>
        <option value="Pasaporte">Pasaporte</option>
      </SelectInput>
    </SelectContainer>
  );
};

export default DocumentSelectInput;
